import { useRef } from 'react';
import QuestionGroupComponent from '../question-group';
import { useFindPermissions } from '../../../utils/helpers/useFindPermissions';
type StationsListProps = {
  stations: any;
  onScrollToStation: (scrollToStation: (index: number) => void) => void; // Accept scrollToStation as a prop
};

const StationsList = ({
  stations = [],
  onScrollToStation,
}: StationsListProps) => {
  const { canAiAudit } = useFindPermissions();
  const stationRefs = useRef<(HTMLDivElement | null)[]>([]);

  const scrollToStation = (index: number) => {
    if (stationRefs.current[index]) {
      stationRefs.current[index]?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };
  onScrollToStation(scrollToStation);

  return (
    <div>
      {stations?.map((item: any, index: number) => (
        <div
          key={index}
          ref={(el) => (stationRefs.current[index] = el)} // Assign ref to each station
        >
          <QuestionGroupComponent
            key={index}
            data={item?.data}
            title={item?.title}
            index={index}
            aishow={canAiAudit}
          />
        </div>
      ))}
    </div>
  );
};

export default StationsList;
